import { Component } from "react";
import { API } from "../lib/api";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[CassiaConcept] render error", error, info);
    try {
      fetch(`${API}/client-errors`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: String(error?.message || error),
          stack: String(error?.stack || "").slice(0, 4000),
          component_stack: String(info?.componentStack || "").slice(0, 4000),
          url: window.location.href,
          user_agent: navigator.userAgent,
        }),
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  }

  reset = () => {
    try {
      ["cc_cart", "cc_wishlist", "cc_compare", "cc_user"].forEach((k) => window.localStorage.removeItem(k));
    } catch {
      /* ignore */
    }
    window.location.href = "/";
  };

  render() {
    if (!this.state.error) return this.props.children;
    const { error } = this.state;
    return (
      <div data-testid="error-boundary" className="min-h-screen flex items-center justify-center px-6 text-center">
        <div className="max-w-xl">
          <p className="eyebrow mb-3">Ceva nu a mers</p>
          <p className="font-serif text-4xl font-light">Pagina nu s-a putut încărca</p>
          <p className="text-sm text-[#737373] mt-3 max-w-sm mx-auto">Reîncarcă pagina sau resetează datele demo salvate în browser.</p>
          <div className="mt-8 flex gap-3 justify-center">
            <button data-testid="error-reload" onClick={() => window.location.reload()} className="btn-primary">Reîncarcă</button>
            <button data-testid="error-reset" onClick={this.reset} className="btn-outline">Resetează demo</button>
          </div>
          <pre data-testid="error-details" className="mt-10 text-left text-[11px] leading-relaxed text-[#9A9A9A] whitespace-pre-wrap break-words surface p-4">
            {String(error?.message || error)}
            {"\n"}
            {String(error?.stack || "").split("\n").slice(0, 4).join("\n")}
          </pre>
        </div>
      </div>
    );
  }
}
